import React from "react";
import { Info } from "lucide-react";
import "./DocumentsPage.css";

export default function DocumentsPage() {
  return (
    <main id="main" className="documents-page" data-testid="documents-page">
      <header className="documents-hero">
        <div className="documents-hero-inner">
          <span className="documents-eyebrow">Documents — Ressources validées</span>
          <h1 className="documents-title">BIBLIOTHÈQUE<br /><span>TECHNIQUE.</span></h1>
          <p className="documents-intro">Les ressources publiées ici sont mises en ligne par SI2T.</p>
        </div>
      </header>
      <div className="documents-main">
        <div className="documents-notice"><Info size={16} /><p>Aucun fichier privé ni document fictif n'est publié sur cette page.</p></div>
        <div className="documents-empty" data-testid="documents-empty">
          <p className="documents-empty-title">Bibliothèque en cours de constitution.</p>
          <p className="documents-empty-text">Aucun document public validé n'est disponible pour le moment.</p>
        </div>
      </div>
    </main>
  );
}
